import { getIsAIPlannerPanelOpen } from '@bridebook/web/lib/ai-planner/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';
import { memo, useState } from 'react';

const AIPlannerPanel = lazyComponent(
  () => import('@bridebook/web/components/ai-planner/ai-planner-panel'),
);

/**
 * Loads the planner panel only when it first opens, because it pulls in the whole planner UI.
 * The lazy load must live outside the module it loads. Once loaded it stays mounted,
 * so the panel can animate its own close.
 */
const AIPlannerPanelLazy = () => {
  const isOpen = useSelector(getIsAIPlannerPanelOpen);
  const [hasOpened, setHasOpened] = useState(isOpen);
  if (isOpen && !hasOpened) setHasOpened(true);
  return hasOpened ? <AIPlannerPanel /> : null;
};

// Memoised: it takes no props, and its parent re-renders with the whole page layout.
export default memo(AIPlannerPanelLazy);
